module.exports = __webpack_public_path__ + "img/icon9.b03a86b9.png";